import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { propTypes as reduxFormPropTypes, reduxForm } from 'redux-form';
import SaveSelectionForm from '../../common/components/SaveSelectionForm';

const validate = (values, props) => {
  const errors = {};
  const maxLength = 255;
  const field = 'name';

  if (!values[field]) {
    errors[field] = (
      <div id="mandatory">
        <FormattedMessage id="app.field.mandatory" values={{ field }} />
      </div>
    );
  } else if (!values[field].trim()) {
    errors[field] = (
      <div id="not-blank">
        <FormattedMessage id="app.field.not.blank" values={{ field }} />
      </div>
    );
  } else if (values[field].length > maxLength) {
    errors[field] = (
      <div id="max-length">
        <FormattedMessage id="app.field.max.length" values={{ field, maxLength }} />
      </div>
    );
  } else if (_.find(props.selections, { name: values[field] })) {
    errors[field] = (
      <div id="already-used">
        <FormattedMessage id="app.field.already.used" values={{ field, maxLength }} />
      </div>
    );
  } else if (props.checkedMailProcessingCenters && !props.checkedMailProcessingCenters.length) {
    errors[field] = (
      <div id="no-impcs-selected">
        <FormattedMessage id="app.no.impcs.selected" />
      </div>
    );
  }

  return errors;
};

// eslint-disable-next-line react/prefer-stateless-function
class SaveIMPCSelectionFormContainer extends Component {
  render() {
    const {
      onCloseModal,
      submitting,
      valid,
      errorMessage,
      pristine,
      handleSubmit,
    } = this.props;

    return (<SaveSelectionForm
      onCloseModal={onCloseModal}
      submitting={submitting}
      valid={valid}
      errorMessage={errorMessage}
      pristine={pristine}
      handleSubmit={handleSubmit}
    />);
  }
}

SaveIMPCSelectionFormContainer.propTypes = {
  ...reduxFormPropTypes,
  onCloseModal: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
};

SaveIMPCSelectionFormContainer.defaultProps = {
  errorMessage: '',
};

export default reduxForm({
  form: 'saveSelection',
  validate,
})(SaveIMPCSelectionFormContainer);
